/**
 * Typed keywords, comma-separated, as the list the server takes. Only splits and trims:
 * the server's `normalizeKeywords` owns the spelling (lower case, one space, once each).
 */
export const keywordList = (typed: string): string[] =>
  typed
    .split(',')
    .map((k) => k.trim())
    .filter((k) => k.length > 0);
